import type { RequestParams } from '../requests/http-client';
import { HttpClient } from '../requests/http-client';
import type { BaseErrorResponse, Cs2EventTypeVariableVM } from './data-contracts';


export default function useEventType() {
  class EventType<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Event Type
     * @name EventTypeControllerGetVariables
     * @summary Returns a list of event type variables
     * @request GET:/cs2/event-type/{eventTypeId}/variables
     * @secure
     * @response `200` `(Cs2EventTypeVariableVM)[]`
     * @response `400` `BaseErrorResponse`
     */
    eventTypeControllerGetVariables = (eventTypeId: number, params: RequestParams = {}) =>
      this.request<Cs2EventTypeVariableVM[], BaseErrorResponse>({
        path: `/cs2/event-type/${eventTypeId}/variables`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new EventType();
}
